import Cookie from 'js-cookie';

export const setCookie = (cookieId: string, expiration_days = 9999) => {
  Cookie.set(cookieId, '1', {
    expires: expiration_days,
    path: '/',
  });
};

export const getCookie = (cookieId: string) => {
  return Cookie.get(cookieId);
};
